"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindMatchingPlanBasedOnVariants = void 0;
var _productHelpers = require("./productHelpers");
var FindMatchingPlanBasedOnVariants = exports.FindMatchingPlanBasedOnVariants = function FindMatchingPlanBasedOnVariants(_ref) {
  var productDefinition = _ref.productDefinition,
    productGroup = _ref.productGroup,
    selectedOptions = _ref.selectedOptions,
    AllPlans = _ref.AllPlans,
    AddOnsMap = _ref.AddOnsMap;
  // NOTE: This is only called if the products are merged
  // This helper is used if the variants and base are displayed in a merged view to
  // determine based on the selected options which plan is the appropriate plan
  var groupSelectedOptions = selectedOptions.merged[productGroup];
  var _productDefinition$is = productDefinition.isVariant,
    isVariant = _productDefinition$is === void 0 ? false : _productDefinition$is,
    basePlanNo = productDefinition.basePlanNo;
  var baseProductDefinition = isVariant ? AllPlans["Plan_".concat(basePlanNo)] : productDefinition;
  var basePlanNumber = baseProductDefinition.planNumber;
  var variantsMap = AddOnsMap[basePlanNumber];
  var selectedLevelOfCover = parseInt(groupSelectedOptions === null || groupSelectedOptions === void 0 ? void 0 : groupSelectedOptions.levelOfCover, 10);
  var selectedAnnualLimit = parseInt(groupSelectedOptions === null || groupSelectedOptions === void 0 ? void 0 : groupSelectedOptions.annualLimit, 10);
  var PlanHasLevelOfCover = function PlanHasLevelOfCover(_ref2) {
    var productDefinition = _ref2.productDefinition;
    // The upmExcessOptions need to include the levelOfCover for it to be a proper match
    var upmExcessOptions = productDefinition.upmExcessOptions;
    var baseLevelsOfCover = (0, _productHelpers.GetLevelsOfCoverFromExcessOptions)({
      upmExcessOptions: upmExcessOptions
    });
    return baseLevelsOfCover.indexOf(selectedLevelOfCover) !== -1;
  };
  var baseHasLevelOfCover = PlanHasLevelOfCover({
    productDefinition: baseProductDefinition
  });
  var planHasLevelOfCover = PlanHasLevelOfCover({
    productDefinition: productDefinition
  });
  var IsAddOnMatch = function IsAddOnMatch(plan, addOn) {
    var planHasAddOn = plan.addOns.indexOf(addOn) !== -1;
    var selectionHasAddOn = (groupSelectedOptions === null || groupSelectedOptions === void 0 ? void 0 : groupSelectedOptions[addOn]) === 'yes';
    if (planHasAddOn && selectionHasAddOn || !planHasAddOn && !selectionHasAddOn) {
      return true;
    }
    return false;
  };
  var IsBaseAddOnMatch = function IsBaseAddOnMatch(addOn) {
    var basePlanHasAddOn = baseProductDefinition[addOn];
    var selectionHasAddOn = (groupSelectedOptions === null || groupSelectedOptions === void 0 ? void 0 : groupSelectedOptions[addOn]) === 'yes';
    if (basePlanHasAddOn && selectionHasAddOn || !basePlanHasAddOn && !selectionHasAddOn) {
      return true;
    }
    return false;
  };
  var BaseHasAddOns = function BaseHasAddOns() {
    if (!IsBaseAddOnMatch('dental')) {
      return false;
    }
    if (!IsBaseAddOnMatch('routineCare')) {
      return false;
    }
    return true;
  };
  var isBaseAnnualLimit = function isBaseAnnualLimit(_ref3) {
    var _baseProductDefinitio;
    var baseProductDefinition = _ref3.baseProductDefinition;
    return selectedAnnualLimit === (baseProductDefinition === null || baseProductDefinition === void 0 || (_baseProductDefinitio = baseProductDefinition.limits) === null || _baseProductDefinitio === void 0 || (_baseProductDefinitio = _baseProductDefinitio.annualLimit) === null || _baseProductDefinitio === void 0 ? void 0 : _baseProductDefinitio.amount);
  };
  if (BaseHasAddOns() && baseHasLevelOfCover && isBaseAnnualLimit({
    baseProductDefinition: baseProductDefinition
  })) {
    return {
      selectedProduct: baseProductDefinition,
      selectedAddOns: groupSelectedOptions
    };
  }

  // Find the plan number from the variants map that has the same plan options
  var matchingVariantPlan = variantsMap && variantsMap.find(function (plan) {
    // Check if the plan.addOns includes all the selectedAddOns
    if (plan.levelOfCover && plan.levelsOfCover.indexOf(selectedLevelOfCover) === -1) {
      return false;
    }
    if (!IsAddOnMatch(plan, 'dental')) {
      return false;
    }
    if (plan.annualLimit !== selectedAnnualLimit) {
      return false;
    }
    if (!IsAddOnMatch(plan, 'routineCare')) {
      return false;
    }
    return plan;
  });
  if (matchingVariantPlan) {
    var matchingProductDefinition = AllPlans["Plan_".concat(matchingVariantPlan.planNumber)];
    return {
      selectedProduct: matchingProductDefinition,
      selectedAddOns: groupSelectedOptions
    };
  }
  if (!baseHasLevelOfCover || !BaseHasAddOns()) {
    // TODO: Work out what happens in this scenario
    //  ?? Implement closest match logic and force a radio state?
    // eslint-disable-next-line no-console
    console.log("There is an issue with the product setup.\n    The chosen combination ".concat(JSON.stringify(groupSelectedOptions, null, 4), "\n    cannot be achieved with any of the plans for this brand."));
  }
  return {
    selectedProduct: isVariant && planHasLevelOfCover ? productDefinition : baseProductDefinition,
    selectedAddOns: groupSelectedOptions
  };
};